"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerFooterClassNames: function() {
        return drawerFooterClassNames;
    },
    useDrawerFooterStyles_unstable: function() {
        return useDrawerFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const drawerFooterClassNames = {
    root: 'fui-DrawerFooter'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1nwgn83", "r4bpumq", [
    ".r1nwgn83{padding-top:var(--spacingVerticalL);padding-right:var(--spacingHorizontalXXL);padding-bottom:var(--spacingVerticalXXL);padding-left:var(--spacingHorizontalXXL);width:100%;max-width:100%;display:flex;justify-content:flex-start;align-items:center;column-gap:var(--spacingHorizontalS);box-sizing:border-box;}",
    ".r4bpumq{padding-top:var(--spacingVerticalL);padding-left:var(--spacingHorizontalXXL);padding-bottom:var(--spacingVerticalXXL);padding-right:var(--spacingHorizontalXXL);width:100%;max-width:100%;display:flex;justify-content:flex-start;align-items:center;column-gap:var(--spacingHorizontalS);box-sizing:border-box;}"
]);
const useDrawerFooterStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(drawerFooterClassNames.root, styles, state.root.className);
    return state;
}; //# sourceMappingURL=useDrawerFooterStyles.styles.js.map
